import { render, staticRenderFns } from "./home.vue?vue&type=template&id=ea724f50&scoped=true&"
var script = {}
import style0 from "./home.vue?vue&type=style&index=0&id=ea724f50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea724f50",
  null
  
)

export default component.exports